import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Desde el día 3 ya me sentía diferente. Nunca pensé que cambios tan simples harían tanta diferencia.',
  author: 'María G.'
}, {
  quote: 'Lo mejor es que no es una dieta restrictiva. Son hábitos reales que puedo mantener.',
  author: 'Ana L.'
}, {
  quote: 'Por $6.36 fue la mejor inversión para mi bienestar este año.',
  author: 'Carmen R.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function TestimonialsSection() {
  return <section className="bg-wellness-light-sage py-24 px-6" id="testimonials" data-id="element-118">
      <div className="max-w-7xl mx-auto" data-id="element-119">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-120">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-wellness-dark mb-4" data-id="element-121">
            Lo que dicen otras mujeres
          </h2>
          <p className="text-lg text-wellness-dark/70 max-w-2xl mx-auto" data-id="element-122">
            Resultados reales de mujeres que decidieron priorizar su bienestar.
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-123">
          {testimonials.map((testimonial, index) => <motion.div key={index} variants={itemVariants} className="bg-white rounded-3xl p-8 shadow-lg shadow-wellness-dark/5 flex flex-col h-full relative" data-id="element-124">
              <div className="absolute -top-4 left-8 text-6xl text-wellness-sage/20 font-serif leading-none" data-id="element-125">
                "
              </div>

              <div className="flex gap-1 mb-6 relative z-10" data-id="element-126">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-wellness-gold text-wellness-gold" data-id="element-127" />)}
              </div>

              <p className="text-wellness-dark/80 italic text-lg leading-relaxed flex-grow relative z-10" data-id="element-128">
                "{testimonial.quote}"
              </p>

              <div className="mt-8 pt-6 border-t border-wellness-light-sage relative z-10" data-id="element-129">
                <p className="font-bold text-wellness-dark" data-id="element-130">
                  {testimonial.author}
                </p>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}